(function () {
    var autocomplete;

    var form = {
        route: ['street_address', 'long_name'],
        locality: ['city', 'long_name'],
        administrative_area_level_1: ['state', 'short_name'],
        postal_code: ['zipcode', 'short_name']
    };

    function init() {
        var autocomplete = new google.maps.places.Autocomplete(
            (document.getElementById('company')), {
                types: ['establishment']
            });

        autocomplete.addListener('place_changed', function () {
            setCompany(autocomplete);
        });

    }

    function normalize(addressType, val, place) {
        if (addressType === 'administrative_area_level_1') {
            val = val.toLowerCase();
        } else if (addressType === 'route') {
            var number = place.address_components[0].long_name;

            if (number.length > 0) {
                if (val !== number) {
                    val = number + " " + val;
                }
            }
        }

        return val;
    }

    function resetInput(addressType) {
        $('#' + addressType).parent().find('label').addClass('active');
        if (addressType === 'state') {
            $("#state").material_select();
        }
    }

    function setCompany(autocomplete) {
        var place = autocomplete.getPlace();

        var place_id = place.place_id;
        var place_name = place.name;

        $('#company').val(place_name);

        $('#place_id').val(place_id);

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (form[addressType]) {
                var val = place.address_components[i][form[addressType][1]];

                val = normalize(addressType, val, place);

                document.getElementById(form[addressType][0]).value = val;

                resetInput(form[addressType][0]);
            }
        }
    }

    if (window.Client === undefined) {
        window.Client = {};
    }

    window.Client.init = init;
})();